const signInDetails = JSON.parse(sessionStorage.getItem('SignInDetails'));
const PreviousSuperAdminID = JSON.parse(sessionStorage.getItem('PreviousSuperAdminID')) || null;
const PreviousCompanyID = JSON.parse(sessionStorage.getItem('PreviousCompanyID')) || null;
const storedCompanyID = signInDetails ? signInDetails[0].CompanyID : null;
const storedCompanyCode = signInDetails ? signInDetails[0].CompanyCode : null;
console.log(signInDetails, 'signInDetails')
let addedByID = null; // Use consistent naming (camelCase)

if (signInDetails && signInDetails[0]) {
    const signInDetails = JSON.parse(sessionStorage.getItem('SignInDetails'));
    if (PreviousSuperAdminID) {
        // Handle the "Switch to Client" case with PreviousSuperAdminID
        addedByID = signInDetails[0].CompanyID +
            '-' + signInDetails[0].SignInType +
            '-' + PreviousSuperAdminID;
    } else if (PreviousCompanyID) {
        // Handle the case with PreviousCompanyID
        addedByID = signInDetails[0].SuperAdminID +
            '-' + signInDetails[0].SignInType +
            '-' + PreviousCompanyID;
    } else {
        // Handle the default sign-in case
        const signInType = signInDetails[0].SignInType;

        if (signInType === "SuperAdmin") {
            addedByID = signInDetails[0].SuperAdminID + '-' + signInDetails[0].SignInType;
        } else if (signInType === "ClientAdmin") {
            addedByID = signInDetails[0].CompanyID + '-' + signInDetails[0].SignInType;
        } else if (signInType === "User") {
            addedByID = signInDetails[0].UserID + '-' + signInDetails[0].SignInType;
        }
    }
}

export const ADDED_BY_ID = addedByID;
export const Company_ID = storedCompanyID;
export const Company_Code = storedCompanyCode;